module.exports = __webpack_public_path__ + "static/img/IP-zhp.8b92d5a6.webp";